export const HTTP_UNPROCESSABLE_ENTITY = 422;

export const HTTP_INTERNAL_SERVER_ERROR = 500;

export const HTTP_NOT_FOUND = 404;

export const HTTP_UNAUTHORIZED = 401;